var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"kpi-direction-message-in-header"},[_c(_setup.FavorabilityIcon,{attrs:{"less_is_better":_vm.less_is_favorable,"size":24,"color":"Grey"}}),_c('span',{staticClass:"message"},[_vm._v(_vm._s(_setup.messageText))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }